export default "__VITE_ASSET__d4832562__"